<template>
  	<div class="container-fluid pt-3 text">
  		<div class="m-2">
      		<div class="alert alert-primary h4 text-center">
          		<linkto :link="'/'"/>
          		Ki mikor rendelt utoljára
      		</div>
    	</div>
    	<loading
    		:active.sync="isLoading" 
	      	:is-full-page="true"
	      	:can-cancel="true"
	      	color="#007bff"
	    	background-color="#ffffff"
	    >
	    </loading>
    	<back-to-top bottom="50px" right="50px">
      		<button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
    	</back-to-top>
		<div class="row d-flex justify-content-center">
			<div class="col-6 col-md-6 col-lg-3 text-center">
			    <span class="h5">Régió</span>
			    <div class="input-group">
			      <input type="number" class="form-control text-center" v-model="search.regio_kezd"></input>
			      <input type="number" class="form-control text-center" v-model="search.regio_veg"></input>
			    </div>
			</div>
      <div class="col-6 col-md-6 col-lg-3 text-center">
          <div>
              <span class="h5">Gyorsválasztó</span>  
          </div>
          <div>
            <button
              type="button"
              class="btn-block text-center btn btn-outline-primary"
              @click.prevent="regio(1000,1999)"
            >
            1000-1999 Régió
          </button>
          </div>
      </div>
			<div class="col-6 col-md-6 col-lg-3 text-center">
			    <div>
			      	<span class="h5">Gyorsválasztó</span>  
			    </div>
			    <div>
				    <button
				    	type="button"
				    	class="btn-block text-center btn btn-outline-primary"
				    	@click.prevent="regio(5000,5999)"
				    >
						5000-5999 Régió
					</button>
			  	</div>
			</div>
			<div class="col-6 col-md-6 col-lg-3 text-center">
			    <div>
			      	<span class="h5">Gyorsválasztó</span>  
			    </div>
			    <div>
				    <button
				    	type="button"
				    	class="btn-block text-center btn btn-outline-primary"
				    	@click.prevent="regio(6000,6999)"
				    >
						6000-6999 Régió
					</button>
				</div>
			</div>
      <div class="col-6 col-md-6 col-lg-3 text-center">
          <div>
              <span class="h5">Gyorsválasztó</span>  
          </div>
          <div>
            <button
              type="button"
              class="btn-block text-center btn btn-outline-primary"
              @click.prevent="regio(7000,7999)"
            >
            7000-7999 Régió
          </button>
          </div>
      </div>
		</div>

      	<div class="row d-flex justify-content-center mt-1">
      		<div class="h5 col-12 text-center">Nem rendelt</div>
          <div class="col-6 col-md-6 col-lg-3 text-center">
              <button
                  type="button"
                  class="btn-block text-center btn m-1"
                  @click.prevent="[day(0,10000), active_btn = 1]"
                  :class="active_btn == 1 ? 'btn-primary' : 'btn-outline-primary'"
              >
                Minden dátum
              </button>
          </div>
      		<div class="col-6 col-md-6 col-lg-3 text-center">
              	<button
	              	type="button"
	              	class="btn-block text-center btn m-1"
	              	@click.prevent="[day(0,10), active_btn = 2]"
	              	:class="active_btn == 2 ? 'btn-primary' : 'btn-outline-primary'"
	            >
	         		0 - 10 napja
	         	</button>
            </div>
        	<div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 text-center">
            	<button
              		type="button"
              		class="btn-block text-center btn m-1"
              		@click.prevent="[day(11,30), active_btn = 3]"
              		:class="active_btn == 3 ? 'btn-primary' : 'btn-outline-primary'"
              	>
              		10 - 30 napja
              	</button>
            </div>
        	<div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 text-center">
              	<button
              		type="button"
              		class="btn-block text-center btn m-1"
              		@click.prevent="[day(31,10000), active_btn = 4]"
              		:class="active_btn == 4 ? 'btn-primary' : 'btn-outline-primary'"
              	>
              		Több mint 30 napja
              	</button>
            </div>
      	</div>

      	<div class="row d-flex justify-content-center align-items-center">
            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Ügyfél kategória</span>
                <select v-model="search.kategoria_id" class="form-control m-1">
                  <option v-for="(item,index) in kat" :value="item.kszam">
                    {{item.nev}}
                  </option>
                </select>
            </div>
            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Ügyfél típus</span>
                <select v-model="search.tipus_id" class="form-control m-1">
                  <option v-for="(item,index) in tip" :value="item.kszam">
                    {{item.nev}}
                  </option>
                </select>
            </div>
            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Automata</span>
                <select v-model="search.automataa" class="form-control m-1">
                  <option value="0">Nincs</option>
                  <option value="1">Van</option>
                  <option value="2">Mindkettő</option>
                </select>
            </div>
            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Automata szerződés</span>
                <select v-model="search.automata_szerz" class="form-control m-1">
                  <option value="0">Nincs</option>
                  <option value="1">Van</option>
                  <option value="2">Mindkettő</option>
                </select>
            </div>
        	<div class="col-6 col-md-4 col-lg-2">
            	<button @click.prevent="load" class="btn btn-block btn-primary m-1">
              		<i class="fas fa-search"></i>
              		<span class="font-weight-bold">Keresés</span>
            	</button>
        	</div>
        	<div class="col-6 col-md-4 col-lg-2">
            	<button class="btn btn-block btn-outline-success m-1" disabled v-show="items.length > 0">
              		<span class="font-weight-bold">{{ items.length }} ügyfél</span>
            	</button>
            	<button class="btn btn-block btn-outline-warning m-1" disabled v-show="items.length < 1">
              		<span class="font-weight-bold">Sajnos nincs találat</span>
            	</button>
        	</div>
      	</div>
      
     	<div>
     		<hr>
     	</div>
      
      <kimikor-item
        v-for="(v,k) in items"
        :key="k"
        :obj="v"
      >
        
      </kimikor-item>
      
    </div>
</template>

<script>
import kimikorItem from './kimikorItem'
export default {
  	name: 'Kimikor',

    components: {
      kimikorItem
    },

  	data () {
        return {
            active_btn: 2,
            search: {
                diff_kezd: 0,
                diff_veg: 10,
                regio_kezd: 0,
                regio_veg: 9999,
                automataa: 2,
                automata_szerz: 2,
                kategoria_id: 0,
                tipus_id: 0
            },
            items: [],
            kat: [],
            tip: []
        }
    },

    mounted(){
        this.$Progress.start()
        this.isLoading = true
        this.req.post(`/others`)
            .then(res => {
                this.kat = res.data.kat
                this.kat.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden", "megjegyzes": null })
                this.tip = res.data.tip
                this.tip.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden", "megjegyzes": null })
                this.$Progress.finish()
                this.isLoading = false
            })
            .catch(err => {
                this.$Progress.fail()
                this.isLoading = false
            })
    },

  	methods: {
  		load() {
    			this.$Progress.start()
    			this.isLoading = true
    			this.req.post(`/stats/kimikor`,this.search)
    				  .then(res => {
                  this.items = res.data.list
      				  	this.$Progress.finish()
      				  	this.isLoading = false
    				  })
    				  .catch(err => {
                  console.log(err)
        					this.$Progress.fail()
        					this.isLoading = false
    				})
    	},

  		toJson(array){
  	  		return JSON.parse(array)
  		},

  		regio(kezd,veg){
      		this.search.regio_kezd = kezd
      		this.search.regio_veg = veg
    	},

    	day(from,to){
    		  this.search.diff_kezd = from
    		  this.search.diff_veg = to
    	}
  }
}
</script>

<style scoped>
.text {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/stats/kimikor.vue